<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card style="min-width: 550px" class="card-authorization">
        <q-card-section class="header" v-show="showIcon">
          <div class="text-h6 text-center" id="title-card-authorization">
            <q-icon name="o_delete" style="color: #002f6c; font-size: 50px" />
          </div>
        </q-card-section>
        <q-card-section class="container-desauth q-pt-none q-col-gutter-y-sm">
          <div class="title-delete text-center">
            {{ txtContainer }}
          </div>
        </q-card-section>
        <q-card-actions align="center" class="text-primary container-actions">
          <q-btn data-cy='cancelDelete' flat label="Cancelar" padding="xs lg" v-close-popup @click="cancel()" />
          <q-btn
            :data-cy="dataCy"
            :label="labelDelete"
            color="primary"
            padding="xs lg"
            @click="remove()"
            :loading="isLoading"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog } from 'quasar';
export default {
  components: {
    QDialog
  },
  props: {
    value: {
      required: true
    },
    showIcon: {
      required: false,
      type: Boolean,
      default: () => false
    },
    txtContainer: {
      required: true,
      type: String,
      default: () => 'Default Txt'
    },
    dataCy: {
      required: false,
      type: String,
      default: () => ''
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: () => false
    },
    labelDelete: {
      required: false,
      type: String,
      default: () => 'Si, eliminar'
    }
  },
  data () {
    return {
      valueLocal: this.value
    };
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    },
    remove () {
      this.$emit('save');
    }
  },
  watch: {
    value: {
      handler: function () {
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-desauth {

    .title-delete {
      padding: 11px 20px 30px 20px;
      font-family: 'DINPro-Bold';
      font-size: 22px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #4d4d4d;
    }
  }
  .container-actions {
    padding-bottom: 30px;
  }
</style>
